import { Container, Stack, Typography } from "@mui/material";
import React from "react";
import LoginForm from "../forms/Login";
import UserCompteForm from "../forms/RegisterForm";
import theme from "../../theme";

export default function LoginSection({onLogin}) {
    const [haveAccount, setHaveAccount] = React.useState(true);

    return haveAccount ? 
    <Container sx={{ display:'flex', flexDirection:'column', minWidth: '300px' }}>
        <LoginForm {...{onLogin}} />
        <Typography variant="body1" sx={{ mb: 2, alignSelf: 'end' }}>
            Pas encore de compte ?
            <span style={{ cursor: 'pointer', color: theme.palette.focus.main, marginLeft: '5px' }}
                    onClick={() => setHaveAccount(false)}>Je m'inscris</span>
        </Typography>
    </Container> 
    : 
    <Container sx={{ display:'flex', flexDirection:'column', minWidth: '400px' }}>
        <UserCompteForm {...{onLogin}} />
        <Typography variant="body1" sx={{ mb: 4, alignSelf: 'end' }}>
            Déjà inscrit ?
            <span style={{ cursor: 'pointer', color: theme.palette.focus.main, marginLeft: '5px' }}
                    onClick={() => setHaveAccount(true)}>Je me connecte</span>
        </Typography>
    </Container>
}